//@ts-nocheck
import React from "react";
import { hasValue, isEqual } from "../../lib/utils";

interface PropsType {
  showTitle: string | number | boolean | null;
}

export default function TitleHandler(props: PropsType) {
  const { showTitle } = props;
  if (
    !hasValue(showTitle) ||
    isEqual(showTitle, 0) ||
    isEqual(showTitle, false)
  ) {
    return <></>;
  }
  return <></>;
}
